import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

type RedeemDesktopSignInResult = {
  token: string;
};

export const redeemDesktopSignIn = async (
  code: string,
  verifier: string,
): Promise<string> => {
  const functions = getFunctions();
  const redeem = httpsCallable<
    { code: string; verifier: string },
    RedeemDesktopSignInResult
  >(functions, 'users-redeemDesktopSignIn');

  const { data } = await redeem({ code, verifier });

  return data.token;
};
